<template>
    <div>
        <div class="detail_title">
            更新方法：在输入框中直接修改，更新完后点击空白地方更新，请谨慎操作！
        </div>
        <div class="field_box">
            <div v-for="(item, i) in columns">
                <div class="field_item" v-if="type_list.indexOf(item.type) == -1">

                    <div class="title">{{ item['title'] }}:</div>

                    <!-- 手机号 -->
                    <div v-if="item.key == 'field_id_fdc7aad2af'">
                        <Input :disabled='true' size="small" @on-blur="input_blur(item, roster_item[item['key']])"
                            v-model="roster_item[item['key']]" placeholder-style="font-size:10px" placeholder="请输入内容"
                            style="width: 200px" />
                        <span class="update_phone_span" @click="click_update_phone(roster_item, item)">更新手机号</span>

                    </div>
                    <div v-else>
                        <Input :disabled='item.disabled' size="small"
                            @on-blur="input_blur(item, roster_item[item['key']])" v-model="roster_item[item['key']]"
                            placeholder-style="font-size:10px" placeholder="请输入内容" style="width: 300px" />
                    </div>



                </div>
            </div>
        </div>
        <!-- 更新手机号 -->
        <Modal v-model="update_phone_show" title="更新手机号" :footer-hide="true" width="300">
            <div>
                <Input maxlength="11" v-model="update_phone_value" placeholder="输入11位手机号码" style="width: 200px" />
            </div>
            <div class="update_phone_button">
                <Button type="primary" @click="update_phone">确认更新</Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import { context } from 'vue'
export default {
    props: [
        "roster_item",
        'columns',
        'project_id',
        'resume_id'
    ],
    name: 'editor',
    data() {
        return {

            type_list: [
                -1,
                "selection"

            ],
            // 更新手机号
            update_phone_show: false,
            update_phone_value: "",
            update_phone_item: {},
        }
    },

    mounted() {


    },
    methods: {
        click_update_phone(roster_item, item) {
            console.log(roster_item)
            console.log(item)
            this.update_phone_item = roster_item;
            this.update_phone_value = roster_item['field_id_fdc7aad2af'];
            this.update_phone_show = true;
        },


        //失焦变化
        input_blur(item, value) {
            var data = [{
                "field_type": item.type,
                'value': value,
                'field_id': item.key,
            }]

            this.update_data_request(item, data)
        },

        update_data_request(item, update_list) {
            var that = this
            var obj = {
                update_list: update_list,
                project_id: this.project_id,
                resume_id: this.resume_id
            }
            item.disabled = true
            http("post", process.env.VUE_APP_HOST + "/roster_manage/detail/roster_field_update", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        item.disabled = false
                        that.$emit('change', 'ok')

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    item.disabled = false
                }
            ).catch((res) => {
                item.disabled = false
                console.log(res, '请求出错')
            })
        },


        update_phone(row) {
            var that = this;
            var obj = {
                phone: this.update_phone_value,
                resume_id: this.update_phone_item.resume_id,
            };
            http(
                "post",
                process.env.VUE_APP_HOST + "/my_project/daimianshi/update_phone",
                obj,
                true
            )
                .then((res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.update_phone_show = false;
                        that.$emit("change",'phone_change')
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },

        // update_data() {
        //     var update_list = []
        //     for (let i = 0; i < this.columns.length; i++) {
        //         if (this.columns[i]['type'] != -1) {
        //             var _dict = {
        //                 "field_type": this.columns[i]['type'],
        //                 'value': this.roster_item[this.columns[i]['key']],
        //                 'field_id': this.columns[i]['key'],
        //             }

        //             update_list.push(_dict)
        //         }
        //     }
        //     this.update_data_request(update_list)

        // }
    }
}
</script>

<style scoped>
.update_phone_button {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.update_phone_span {
    margin-left: 10px;
    color: #0466dd;
    cursor: pointer;
}

.detail_title {
    font-size: 12px;
    color: rgb(22, 80, 179);
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px dashed #ccc
}

.update_button:hover {
    background-color: #095dc3;
    cursor: pointer;
}


.update_button {
    height: 40px;
    background-color: #0466dd;
    color: #fff;
    text-align: center;
    line-height: 40px;
}

.field_box {
    height: calc(100vh - 130px);
    overflow: auto;
}

.field_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.title {
    font-size: 13px;
    width: 120px;
    flex-shrink: 0;
}
</style>
